/**
 * Individual glossary terms.
 */
const TermRoute = (path) => {

};

export default TermRoute;
